const redirect = (url) => {
  const path = url.toString();
  return location.href = path;
};

export default redirect;
